import { cn } from '@/lib/cn';

type Props = {
  depth: 0 | 1;
  className?: string;
};

/** 一级 / 二级站点层级标签（与站点管理、机器人模块视觉一致） */
export function SiteLevelBadge({ depth, className }: Props) {
  if (depth === 0) {
    return (
      <span
        className={cn(
          'shrink-0 rounded-md bg-slate-800 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white',
          className,
        )}
      >
        一级
      </span>
    );
  }

  return (
    <span
      className={cn(
        'shrink-0 rounded-md bg-emerald-700 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white',
        className,
      )}
    >
      二级
    </span>
  );
}
